import { axiosInstances } from 'utilities/axios/Instances/axios.instances';
const getTemplates = () => {
  return axiosInstances.withAuthToken().get('/templates');
};
const getClients = () => {
  return axiosInstances.withAuthToken().get('/clients');
};
const getTemplateById = id => {
  return axiosInstances.withAuthToken().get(`/templates/${id}`);
};
const getEmployeeById = id => {
  return axiosInstances.withAuthToken().get(`/employees/${id}`);
};
const getAllFeedbacks = () => {
  return axiosInstances.withAuthToken().get(`/feedback`);
};
const createFeedback = data => {
  return axiosInstances.withAuthToken().post(`/feedback`, data);
};

const getFeedbackResponse = id => {
  return axiosInstances.withAuthToken().get(`/feedback/${id}/response`);
};
const feedbackAuthenticate = data => {
  return axiosInstances.withBaseUrl().post(`/feedback/authenticate`, data);
};
const getFeedbackByToken = feedbackToken => {
  return axiosInstances
    .withFeedbackToken()
    .get(`/feedback/token/${encodeURIComponent(feedbackToken)}`);
};

const getFeedbackStatus = feedbackToken => {
  return axiosInstances
    .withBaseUrl()
    .get(`/feedback/token/${encodeURIComponent(feedbackToken)}/status`);
};

const createFeedbackResponse = (feedbackToken, data) => {
  return axiosInstances
    .withFeedbackToken()
    .post(`/feedback/token/${encodeURIComponent(feedbackToken)}/response`, data);
};
export const feedbackService = {
  getTemplates,
  getClients,
  getTemplateById,
  getEmployeeById,
  getAllFeedbacks,
  createFeedback,
  getFeedbackResponse,
  feedbackAuthenticate,
  getFeedbackByToken,
  getFeedbackStatus,
  createFeedbackResponse
};
